import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth.js'
import modulePermission from './user-permission/modulePermissionManagement'
import moduleRole from './role/moduleRoleManagement.js'
import moduleUsers from './user-management/moduleUserManagement'
import moduleTenantCustomer from '@/store/tenant-customer/moduleTenantCustomer.js'
import modulePaymentChannel from '@/store/payment-channel/modulePaymentChannel'
import moduleTransaction from '@/store/transaction/moduleTransaction'
import modulePayment from '@/store/payment/modulePayment'
import moduleBillingDoc from '@/store/billing-doc/moduleBillingDoc'
import moduleBillingDocLinkage from '@/store/billing-doc-linkage/moduleBillingDocLinkage'
import moduleCustomerGroup from '@/store/customer-group/moduleCustomerGroup'
import moduleFile from '@/store/file/moduleFile'
import moduleEmailLog from './email-logs/moduleEmailLog.js'
import moduleEmail from '@/store/email/moduleEmail'
import moduleTenant from '@/store/tenant/moduleTenant'
import moduleEInvoice from '@/store/e-invoice/moduleEInvoice'
import modulePdfTemplate from './pdf-template/modulePdfTemplateManagement'
import moduleTenantPdfTemplate from './tenant-pdf-template/moduleTenantPdfTemplate'
import moduleLhdnSubmissions from '@/store/lhdn-submissions/moduleLhdnSubmissions'
import moduleSgPeppolSubmissions from '@/store/sg-peppol-submissions/moduleSgPeppolSubmissions'
import moduleMyPeppolSubmissions from '@/store/my-peppol-submissions/moduleMyPeppolSubmissions'
import moduleMyPeppolReports from '@/store/my-peppol-reports/moduleMyPeppolReports'
import modulePeppolInboundOrders from '@/store/peppol-inbound-orders/modulePeppolInboundOrders'
import modulePeppolApDocuments from '@/store/peppol-ap-documents/modulePeppolApDocuments'
import moduleApDocuments from '@/store/ap-documents/moduleApDocuments'
import moduleDocumentLedger from '@/store/document-ledger/moduleDocumentLedger'
import moduleAuditTrail from '@/store/audit-trail/moduleAuditTrail'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    permissions: modulePermission,
    role: moduleRole,
    users: moduleUsers,
    tenantCustomers: moduleTenantCustomer,
    paymentChannels: modulePaymentChannel,
    transactions: moduleTransaction,
    payment: modulePayment,
    billingDocs: moduleBillingDoc,
    billingDocLinkages: moduleBillingDocLinkage,
    customerGroups: moduleCustomerGroup,
    files: moduleFile,
    emailLogs: moduleEmailLog,
    emailSmtp: moduleEmail,
    tenant: moduleTenant,
    einvoice: moduleEInvoice,
    pdfTemplates: modulePdfTemplate,
    tenantPdfTemplates: moduleTenantPdfTemplate,
    lhdnSubmissions: moduleLhdnSubmissions,
    sgPeppolSubmissions: moduleSgPeppolSubmissions,
    myPeppolSubmissions: moduleMyPeppolSubmissions,
    myPeppolReports: moduleMyPeppolReports,
    peppolInboundOrders: modulePeppolInboundOrders,
    peppolApDocuments: modulePeppolApDocuments,
    apDocuments: moduleApDocuments,
    documentLedger: moduleDocumentLedger,
    auditTrail: moduleAuditTrail,
  },
  strict: process.env.NODE_ENV !== 'production',
})
